/* src/context/MainContentContext.jsx - Última MOdificación: 26-12-2025 */
/* -------------------------------------------------------------------- */

import { createContext, useContext, useState } from 'react';

const MainContentContext = createContext();

export const MainContentProvider = ({ children }) => {
  const [title, setTitle] = useState('');

  return (
    <MainContentContext.Provider value={{ title, setTitle }}>
      {children}
    </MainContentContext.Provider>
  );
};

export const useMainContent = () => useContext(MainContentContext);
